<h3 mat-dialog-title class="text-wrapper">{{ title }} <span class="dialog-title-name" *ngIf="titleName">{{ titleName }}</span></h3>
<div mat-dialog-content>
    <div [innerHTML]="message"></div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: end; align-items: center; gap: 12px;">
    <button mat-button [mat-dialog-close]="false">{{ cancelText }}</button>
    <button mat-button [mat-dialog-close]="true">{{ confirmText }}</button>
</div>